'use client';
import React, { useEffect, useState } from 'react';
import QuoteCart from '../../components/plc/QuoteCart';
import Link from 'next/link';
import { ArrowLeft } from 'lucide-react';

interface CartItem {
  mpn: string;
  brand?: string;
  description?: string;
  quantity: number;
}

const CART_STORAGE_KEY = 'plciraq_quote_cart';

export default function QuotePage() {
  const [cartItems, setCartItems] = useState<CartItem[]>([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(CART_STORAGE_KEY);
      if (stored) {
        const parsed = JSON.parse(stored);
        if (Array.isArray(parsed)) {
          setCartItems(parsed);
        }
      }
    } catch (err) {
      console.error('[QuotePage] Failed to read cart from localStorage:', err);
    }
    setLoaded(true);
  }, []);

  if (!loaded) {
    return (
      <div className="min-h-screen bg-light-grey flex items-center justify-center">
        <div className="animate-spin rounded-full h-10 w-10 border-4 border-iraqi-red border-t-transparent" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-light-grey py-10 px-4">
      <div className="max-w-3xl mx-auto">
        {/* Back link */}
        <Link
          href="/"
          className="inline-flex items-center gap-2 text-sm text-slate-600 hover:text-iraqi-red transition-colors mb-6 font-roboto"
        >
          <ArrowLeft size={16} />
          Back to Products
        </Link>

        <h1 className="text-3xl font-bold text-onyx font-space-grotesk mb-2">
          Your Quote Cart
        </h1>
        <p className="text-slate-grey font-roboto mb-8">
          Review your selected parts and submit a quote request. We respond within 2 hours.
        </p>

        {cartItems.length === 0 ? (
          <div className="bg-white rounded-xl shadow-lg p-10 text-center">
            <div className="text-5xl mb-4">🛒</div>
            <h2 className="text-xl font-bold text-onyx font-space-grotesk mb-2">
              Your cart is empty
            </h2>
            <p className="text-slate-grey font-roboto mb-6">
              Browse our products and click &ldquo;Add to Quote&rdquo; to get started.
            </p>
            <Link
              href="/"
              className="inline-flex items-center gap-2 bg-iraqi-red hover:bg-primary-dark text-white text-sm font-semibold px-6 py-3 rounded-lg transition-all duration-200 hover:shadow-md font-space-grotesk"
            >
              Browse Products
            </Link>
          </div>
        ) : (
          <QuoteCart initialCart={cartItems} />
        )}
      </div>
    </div>
  );
}
